import { axios, API } from "@/imports-files/common/common";
import {SendRequest} from '@/services/common/send-request';

export class ManageAssessmentService extends SendRequest
{
  async listAssessments(params)
  {
    const url = API.client.manage_assessment.ASSESSMENT_LIST;
    try {
      const result = await axios.get( url,
      {
        params: params,
        headers: this.customHeaderJSON()
      },
      this.setHeaderJSON(),
      this.setCrossDomainTrue(),
      this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async createAssessment(params){
    const url =  API.client.manage_assessment.CREATE_ASSESSMENT;
    try 
    {
      const result = await axios.post(url,
      params,
      this.setHeaderJSON(),
      this.setCrossDomainTrue(),
      this.setCredentialsJSON());
      return result;
    } 
    catch (error) 
    {
      return error;
    }
  }

  async updateAssessment(params, assessmentId){
    const url =  API.client.manage_assessment.UPDATE_ASSESSMENT.replace('$assessment_id', assessmentId);
    try 
    {
      const result = await axios.put(url,
      params,
      this.setHeaderJSON(),
      this.setCrossDomainTrue(),
      this.setCredentialsJSON());
      return result;
    } 
    catch (error) 
    {
      return error;
    }
  }


  async deleteAssessment(assesmentId)
  {
    const url = API.client.manage_assessment.DELETE_ASSESSMENT.replace('$assessment_id', assesmentId);
    try {
      const result = await axios.delete( url,
      {
        params: {},
        headers: this.customHeaderJSON()
      },
      this.setHeaderJSON(),
      this.setCrossDomainTrue(),
      this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }
}